import { defineAsyncComponent } from 'vue'

export const formDefinitions = {
  forms: {
    fields: ['*.*.*.*.*']
  }
}

export const componentsForm = {
  field_texts: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputText.vue')
    )
  },
  field_emails: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputEmail.vue')
    )
  },
  field_telephones: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputPhone.vue')
    )
  },
  field_numbers: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputNumber.vue')
    )
  },
  field_textareas: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/Textarea.vue')
    )
  },
  field_checkboxes: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputCheckboxes.vue')
    )
  },
  field_radioboxes: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputRadioButtons.vue')
    )
  },
  field_dropdowns: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/Select.vue')
    )
  },
  field_file_uploads: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputFile.vue')
    )
  },
  field_image_uploads: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/InputImage.vue')
    )
  },
  field_terms_and_conditions: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/TermsAndConditions.vue')
    )
  },
  field_static_texts: {
    component: defineAsyncComponent(() =>
      import('~/components/components/form/StaticText.vue')
    )
  }
}
